<template>
  <modal-base class="c-modal--blank" v-bind="$attrs">
    <div class="c-modal__content">
      <span class="c-modal__close" @click.stop="close"><svg class="icon icon-cancel icon-primary"><use xlink:href="#icon-cancel"></use></svg></span>

      <slot></slot>
    </div>
  </modal-base>
</template>

<script>
  import ModalBase from './ModalBase.vue';

  export default {
    name: 'ModalBlank',
    
    components: {
      ModalBase
    },

    methods: {
      close () {
        this.$emit('close');
        this.$modal.remove();
      }
    }
  };
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/plugins/modals/ModalBlank.vue